/* Copyright 2025 Supovia LLC */
import getUrl from '@monorepool/env/getUrl.js'
import product from './product.js'

export default function getApiUrl(params) {
  return getUrl({
    product,
    service: 'api',
    ...params,
  })
}
